<template>
  <div style="width: 1200px; margin: auto">
    <div class="buyid">
      <p><span>采购单号:</span>{{ code }}</p>
      <div class="upload">
        <p>
          <el-upload name="files" class="upload-demo" :action="`${$baseUrl}/custom/xunyou/api/common/upload`"
            :on-success="handleAvatarSuccess" :show-file-list="false" :before-upload="beforeAvatarUpload">
            <el-button @click="handelUpload" size="small" type="text"><i class="el-icon-upload2"></i>上传合同</el-button>
          </el-upload>
        </p>
        <p>
          <el-link v-if="info.contractUrl !== null" :underline="false" type="primary" :href="info.contractUrl"
            style="font-size: 12px" target="_blank"><i style="color: #409eff" class="el-icon-download"></i>
            下载合同
          </el-link>
          <span v-else style="margin-left: 30px; font-size: 12px">暂无合同下载</span>
        </p>
      </div>
    </div>

    <div class="main">
      <div class="navs_top">
        <div class="left">
          <div>
            <h3 class="nav_top">标题： {{ info.title }}</h3>
            <div class="nav_content">
              <p>
                <span>送货地址:</span>
                {{ info.address }}
              </p>
              <p>
                <span>招标对接人:</span>
                {{ info.contactPerson }}
              </p>
              <p>
                <span>招标对接联系方式:</span>
                {{ info.phone }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="main_top"></div>
      <div style="position:relative">
        <div class="main-flag">
          <b></b>
          <span>商务要求</span>
        </div>
        <div class="flag_content">
          <p><span>补充说明：</span>{{ info.desc }}</p>
          <p class="ament">
            <span>附件：</span>
            <el-link v-if="info.attachment !== ''" :underline="false" type="primary" :href="info.attachment"
              target="_blank"><i class="el-icon-download"></i>
            </el-link>
            <span v-else>暂无附件</span>
          </p>
        </div>
        <div class="exportBox" v-if="info.type == 4 || info.type == 2 || info.type == 3">
          <el-button type="primary" icon="el-icon-download" @click="exportform" style="margin-right：30px;">模板下载</el-button>
          <el-upload name="file" :show-file-list="false" :data="{ 'purchaseOrderId': info.id }"
            :action="`${$baseUrl}/custom/xunyou/quoteInfo/api/importQuotedPriceTemplate?purchaseOrderId=${info.id}`"
            accept=".xlsx,.xls" list-type="picture" :on-success="handleAvatarSuccess2">
            <el-button type="primary" icon="el-icon-upload2" @click="importform">报价上传</el-button>
          </el-upload>

        </div>
      </div>

      <div class="main_content">
        <template>
          <div class="main-flag">
            <b></b>
            <span>采购商品</span>
          </div>
          <template>
            <el-table v-show="this.typeshop == 1" :header-cell-style="headClass" :data="detailsList" style="width: 100%"
              :summary-method="getSum">
              <el-table-column type="index" label="序号"> </el-table-column>
              <el-table-column prop="productName" label="产品名称">
              </el-table-column>
              <el-table-column prop="spec" label="规格型号">
                <template slot-scope="scope">
                  <span v-if="copydetailsList[scope.$index].spec !== '无'">{{
                    scope.row.spec
                  }}</span>
                  <el-input type="text" v-if="copydetailsList[scope.$index].spec == '无'" v-model="scope.row.spec"
                    class="inputchange">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="technicalRqmts" label="技术参数要求">
                <template slot-scope="scope">
                  <span v-if="copydetailsList[scope.$index].technicalRqmts !== '无'">{{ scope.row.technicalRqmts }}</span>
                  <el-input type="text" v-else v-model="scope.row.technicalRqmts" class="inputchange">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="brand" label="品牌">
                <template slot-scope="scope">
                  <span v-if="copydetailsList[scope.$index].brand !== '无'">{{
                    scope.row.brand
                  }}</span>
                  <el-input type="text" v-if="copydetailsList[scope.$index].brand == '无'" v-model="scope.row.brand"
                    class="inputchange">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="deliverDays" label="时效(天)"></el-table-column>
              <el-table-column prop="quoteDetails.deliverDays" label="发货时效(天)">
                <template slot-scope="scope">
                  <el-input type="text" onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
                    v-model="scope.row.quoteDetails.deliverDays" class="inputchange">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="quoteDetails.accountPeriod" label="账期">
                <template slot-scope="scope">
                  <span v-if="type == 3">{{
                    scope.row.quoteDetails.accountPeriod
                  }}</span>
                  <el-input type="text" v-model="scope.row.quoteDetails.accountPeriod" class="inputchange">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="unit" label="单位"> </el-table-column>
              <el-table-column prop="quotePrice" label="单价(￥)">
                <template slot-scope="scope">
                  <span v-if="type == 3">{{ scope.row.quotePrice }}</span>
                  <el-input @input="
                    priceChange(
                      scope.row.quotePrice,
                      scope.row.priceLimit,
                      scope.$index
                    )
                  " @change="numberChange($event, scope.$index)" max="scope.row.quotePrice" type="text"
                    onkeyup="this.value = this.value.replace(/[^\d.]/g,'');" v-model="scope.row.quotePrice"
                    class="inputchange">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="priceLimit" label="单价上限">
              </el-table-column>
              <el-table-column prop="quoteAmountTotal" label="小计">
                <template slot-scope="scope">
                  {{
                    scope.row.quotePrice === null
                    ? scope.row.quoteAmountTotal
                    : (scope.row.quotePrice * scope.row.number) | showPrice
                  }}
                </template>
              </el-table-column>
              <el-table-column prop="number" label="数量"> </el-table-column>
              <el-table-column prop="remark" label="备注"> </el-table-column>
            </el-table>




          </template>
          <template>
            <el-table v-show="this.typeshop != 1" :header-cell-style="headClass" :data="detailsList" style="width: 100%">
              <el-table-column type="index" label="序号"> </el-table-column>
              <el-table-column prop="projectName" label="项目名称"> </el-table-column>
              <el-table-column prop="workDescs" label="工作描述"> </el-table-column>
              <el-table-column prop="calculateUnit" label="计量单位"> </el-table-column>
              <el-table-column prop="quantities" label="工程量">

              </el-table-column>
              <el-table-column prop="brandAndModel" label="品牌-型号"></el-table-column>
              <el-table-column prop="stuffPrice" label="设备材料单价">
                <template slot-scope="scope">
                  <span v-if="type == 3">{{ scope.row.stuffPrice }}</span>
                  <el-input @input="priceChange2()" max="scope.row.stuffPrice" type="text"
                    onkeyup="this.value = this.value.replace(/[^\d.]/g,'');" v-model="scope.row.stuffPrice"
                    class="inputchange">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="manMadePrice" label="人工单价">
                <template slot-scope="scope">
                  <span v-if="type == 3">{{ scope.row.manMadePrice }}</span>
                  <el-input @input="priceChange2()" max="scope.row.manMadePrice" type="text"
                    onkeyup="this.value = this.value.replace(/[^\d.]/g,'');" v-model="scope.row.manMadePrice"
                    class="inputchange">
                  </el-input>
                </template>
              </el-table-column>
              <el-table-column prop="synthesizePrice" label="综合单价"></el-table-column>
              <el-table-column prop="allPrice" label="合价"></el-table-column>
              <el-table-column prop="remark" label="备注"> </el-table-column>
            </el-table>
          </template>
          <template>
            <el-table v-show="this.typeshop == 13" :header-cell-style="headClass" :data="detailsList" style="width: 100%"
              row-key="id" :load="load" lazy :summary-method="getSum">
              <el-table-column type="index" label="序号"> </el-table-column>
              <el-table-column prop="quotePrice" label="单价(￥)">
                <template slot-scope="scope">
                  <span v-if="type == 3">{{ scope.row.quotePrice }}</span>
                  <el-input v-if="type != 3" @input="
                    priceChange(
                      scope.row.quotePrice,
                      scope.row.priceLimit,
                      scope.$index
                    )
                  " @change="numberChange($event, scope.$index)" max="scope.row.quotePrice" type="text"
                    onkeyup="this.value = this.value.replace(/[^\d.]/g,'');" v-model="scope.row.quotePrice"
                    class="inputchange">
                  </el-input>
                </template>
              </el-table-column>

              <el-table-column prop="service" label="服务名称">
              </el-table-column>
              <el-table-column prop="workDesc" label="工作事项描述">
              </el-table-column>
              <el-table-column prop="servicePeriod" label="服务期限">
              </el-table-column>
            </el-table>
          </template>
        </template>
      </div>
      <!-- 报价备注 -->
      <div>
        <div class="main-flag">
          <span>报价备注</span>
        </div>
        <el-input v-model="form.remark" placeholder="请输入报价备注"></el-input>
      </div>
      <!-- 上传文件 -->
      <el-row>
        <el-upload name="files" class="upload-demo" :action="`${$baseUrl}/custom/xunyou/api/common/upload`"
          :on-success="handleAvatarSuccessfj" :show-file-list="false" :before-upload="beforeAvatarUploadfj">
          <!-- <img :src="urlImg" class="avatar" /> -->
          <el-button size="small" type="text"><i class="el-icon-upload2"></i>上传文件</el-button>
          <span slot="tip" class="el-upload__tip">
            例:
            产品规格书、样品图等（支持jpg、doc、excel、zip等格式）；每个附件最大10M，附件超出10M，请对附件进行压缩或附件内容截图、拍照后上传。
          </span>
        </el-upload>
      </el-row>

      <div class="bottom">
        <div class="nav_right">
          <div class="count" v-if="type == 1">
            合计：<span> {{ sumNumber }}</span>
          </div>

          <el-button :class="type == 1 ? 'startbtn2' : 'startbtn'" @click="handleQuotedPrice()">{{ hasQuoted == 1 ? "再次报价"
            : "立即报价" }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import countDown from "@/components/countDown"; // 倒计时
import { mapState, mapMutations } from "vuex";
import {
  releaseDetails,
  releaseOffer,
  uploadContract,
  detailsForSupplier,
  immediateQuote,
  importQuotedPriceTemplate
} from "@/api/xunyou";
export default {
  data() {
    return {
      accountStatus: JSON.parse(localStorage.getItem("userdata")).accountStatus,
      showSum: "",
      code: "",
      type: JSON.parse(localStorage.getItem("userdata")).type, //1-供应商，3-采购商
      info: "",
      remark: "",
      area: "",
      status: "",
      amount: 0,
      urlImg: "",
      sumNumber: 0,
      url: "",
      loading: true,
      arr: [],
      form: {
        attachment: "",
        userId: JSON.parse(localStorage.getItem("userdata")).userId,
        purchaseOrderId: "",
        remark: "",
      },
      priceflage: "",
      detailsList: [],
      copydetailsList: [],
      hasQuoted: "",
      typeshop: "",
    };
  },
  // 注册组件
  components: {
    countDown,
  },
  created() {
    this.form.purchaseOrderId = this.$route.query.id;
    this.code = this.$route.query.code;
    this.hasQuoted = this.$route.query.hasQuoted;
    this.handelData();
    this.status = this.$route.query.status;
  },
  filters: {
    showPrice(value) {
      value = Number(value);
      return value.toFixed(2);
    },
  },
  computed: {
    ...mapState(["getprovince"]),
  },
  methods: {
    handleAvatarSuccess2(e) {
      console.log(e);
      if(e.code ==0){
        this.$message.success("导入成功!");
        // purchaseOrderId
        this.detailsList = e.data
        this.priceChange2()
      }
      // this.handelData();
    },
    exportform() {
      window.open(`${this.$baseUrl}/custom/xunyou/quoteInfo/api/quotedPriceTemplate?purchaseOrderId=${this.info.id}`
      );
    },
    importform() {
      importQuotedPriceTemplate
    },
    priceChange2() {
      let allMoney = 0;
      // console.log(this.detailsList);
      // this.sumNumber = this.detailsList.reduce((e,v)=>{

      // },0)
      // debugger
      this.detailsList.forEach((val, ind) => {
        val.synthesizePrice = Number(val.stuffPrice == null ? 0 : val.stuffPrice) + Number(val.manMadePrice == null ? 0 : val.manMadePrice)
        val.allPrice = val.synthesizePrice * Number(val.quantities)
        allMoney += val.allPrice
      })
      this.sumNumber = allMoney
    },
    load(tree, treeNode, resolve) {
      this.detailsList = this.detailsList.splice(1, 0);
      setTimeout(() => { }, 1000);
    },
    //查询数据
    handelData() {
      this.loading = false;
      immediateQuote({
        purchaseOrderId: this.form.purchaseOrderId,
        userId: JSON.parse(localStorage.getItem("userdata")).userId,
      }).then((res) => {
        if (res.code == 0) {
          this.info = res.data;
          console.log(this.info)
          if (this.info.type == 1) {
            this.detailsList = res.data.detailsList;
            //记录原始值内容，新建一个地址
            this.copydetailsList = JSON.parse(JSON.stringify(this.detailsList));
            this.form.remark = res.data.quoteDesc;
            this.typeshop = res.data.type;
            let total = 0;
            this.detailsList.forEach((item, index) => {
              console.log(item.quoteDetails, "ques");
              let totalPrice = (item.quotePrice == null ? 0 : item.quotePrice) * (item.number ? item.number : 0);
              console.log("item totalP", item, totalPrice);
              total += Number(totalPrice);
              //看详情里面有没有值purchaseOrderDetails  technicalRqmts   spec   brand
              if (
                null != item.quoteDetails &&
                item.quoteDetails.brand != "" &&
                item.quoteDetails.brand != null
              ) {
                item.brand = item.quoteDetails.brand;
              }
              if (
                null != item.quoteDetails &&
                item.quoteDetails.technicalRqmts != "" &&
                item.quoteDetails.technicalRqmts != null
              ) {
                item.technicalRqmts = item.quoteDetails.technicalRqmts;
              }
              if (
                null != item.quoteDetails &&
                item.quoteDetails.spec != "" &&
                item.quoteDetails.spec != null
              ) {
                item.spec = item.quoteDetails.spec;
              }
              if (null == item.quoteDetails) {
                item.quoteDetails = { accountPeriod: "", deliverDays: "" };
              }
            });
            this.sumNumber = total.toFixed(2);
          } else {
            this.detailsList = res.data.detailsList
            if (this.hasQuoted == 1) {
              this.detailsList = res.data.detailsList.map((val) => {
                return {
                  ...val,
                  stuffPrice: val.quoteDetails.stuffPrice,
                  manMadePrice: val.quoteDetails.manMadePrice
                }
              })
            }
            this.priceChange2()
          }
        }
      });
    },
    // 表头样式设置
    headClass() {
      return "background:#eef1f6;color:black";
    },
    //立即报价
    handleQuotedPrice() {
      if (this.accountStatus == 1) {
        if (this.status !== "5") {
          if (this.typeshop == 1) {
            //5为已经中标
            this.arr = []; //每次提交前清空之前的数组
            var flag = false;
            this.detailsList.forEach((item) => {
              //判断有没有超过最大限制的
              if (
                Number(item.priceLimit) != 0 &&
                Number(item.quotePrice) > Number(item.priceLimit)
              ) {
                flag = true;
                return;
              }
              this.arr.push({
                purchaseOrderId: item.purchaseOrderId,
                purchaseOrderDetailsId: Number(item.id),
                amount: Number(item.quotePrice),
                spec: item.spec,
                technicalRqmts: item.technicalRqmts,
                deliverDaysSupplier: item.deliverDaysSupplier,
                accountPeriod: item.quoteDetails.accountPeriod,
                deliverDays: item.quoteDetails.deliverDays,
                brand: item.brand,
               
              });
              return this.arr;
            });
            if (flag) {
              this.$message.error("当前单价超过单价设置上限!");
              return;
            }
            var obj = {
              ...this.form,
              detailsList: this.arr,
             
            };
            const amountstatus = this.arr.every((i) => i.amount == null);
            if (amountstatus) {
              this.$message({
                type: "info",
                message: "价格不可为空",
              });
            }

            var quotestatus;
            this.detailsList.map((i) => {
              if (i.priceLimit == "") {
                quotestatus = false;
              } else {
                quotestatus =
                  Number(i.quotePrice) > Number(i.priceLimit) ? true : false;
                return quotestatus;
              }
            });
          } else {
            let arr = []
            for (let val of this.detailsList) {
              // if (!Boolean(val.stuffPrice) || !Boolean(val.manMadePrice) ) {
              //   return
              // }
              console.log(val);
              let obj = {
                brandAndModel: val.brandAndModel,
                synthesizePrice: val.synthesizePrice,
                stuffPrice: val.stuffPrice,
                manMadePrice: val.manMadePrice,
                amount: val.allPrice,
                purchaseOrderId: val.purchaseOrderId?val.purchaseOrderId:this.info.id,
                purchaseOrderDetailsId: Number(val.id),
                
              }
              arr.push(obj)
            }

            var obj = {
              ...this.form,
              detailsList: arr,
            };
          }
          obj.quoteControlId =this.$route.query.ids;
          // debugger
          if (this.typeshop == 1 ? !quotestatus : true) {
            releaseOffer(obj).then((res) => {
              if (res.code == 0) {
                this.$message({
                  type: "success",
                  message: "报价成功",
                });
                this.$router.push(`/procurementList`);
              } else {
                this.$message({
                  type: "error",
                  message: res.msg,
                });
              }
            });
          } else {
            this.$message({
              type: "info",
              message: "价格已经大于单价上限,请重新填写",
            });
          }
        } else {
          this.$message({
            type: "info",
            message: "该账户已中标,无法进行报价",
          });
        }
      } else {
        this.$message({
          type: "info",
          message: "该账户已被禁用，不可以进行报价",
        });
      }
    },
    handleAvatarSuccessfj(res, file) {
      this.form.attachment = res.url;
      this.urlImg = URL.createObjectURL(file.raw);
      this.$message.success("附件上传成功!");
    },
    beforeAvatarUploadfj(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过10MB!");
      }
      return isLt2M;
    },
    //选择商品表格内编辑
    //上传合同
    handelUpload() { },
    handleAvatarSuccess(res, file) {
      this.url = res.url;
      if (this.type == 1) {
        //供应商
        uploadContract({
          purchaseOrderId: this.form.purchaseOrderId,
          url: this.url,
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success("合同上传成功");
          } else {
            this.$message.info(res.msg);
          }
        });
      }
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过10MB!");
      }
      return isLt2M;
    },
    getSum(param) {
      const { columns, data } = param;
      const sums = 0;
      columns.forEach((column, index) => {
        if (index === 7) {
          //小计
          const values = data.map((item) => Number(item[column.property]));
          if (!values.every((value) => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);
            sums[index] += " 元";
          } else {
            sums[index] = "N/A";
          }
        }
      });
      sumNumber;
      return sums;
    },
    //计算合计
    priceChange(price, limit, i) {
      let total = 0;
      var that = this;
      this.detailsList.forEach((item, index) => {
        let totalPrice =
          (item.quotePrice == null ? 0 : item.quotePrice) *
          (item.number == null ? 1 : item.number);
        total += Number(totalPrice);
      });
      this.sumNumber = total.toFixed(2);
      //debugger;
      var priceLimit = Number(that.detailsList[i].priceLimit);
      var quotePrice = Number(that.detailsList[i].quotePrice);
      //debugger;
      if (priceLimit != 0 && quotePrice > priceLimit) {
        this.$message.error("当前单价超过单价设置上限!");
      }
    },
    //限制最大值
    numberChange(val, index) {
      if (this.detailsList[index].priceLimit == 0) {
        this.detailsList[index].quotePrice = val;
      } else {
        this.detailsList[index].quotePrice = val;
        if (Number(val) > Number(this.detailsList[index].priceLimit)) {
          this.$message.error("当前单价超过单价设置上限!");
        }
        // this.$nextTick(() => {
        //   let newVal = Math.min(val, this.detailsList[index].priceLimit);
        //   this.detailsList[index].quotePrice = newVal;
        // });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.buyid {
  display: flex;
  justify-content: space-between;
  height: 50px;
  line-height: 50px;
  font-size: 14px;
  margin-left: 30px;

  .upload {
    display: flex;
    justify-content: space-between;
  }

  span {
    color: gray;
  }

  p:last-child {
    cursor: pointer;
    color: gray;

    i {
      margin-left: 10px;
      color: #000;
    }
  }
}

.endtime {
  color: red;
  font-weight: bold;
  margin-right: 50px;
  font-size: 16px;
  margin-top: 10px;
}

.main {
  background-color: white;
  padding: 20px;

  .navs_top {
    display: flex;
    justify-content: space-between;

    .left {
      width: 50%;
    }
  }

  .bottom {
    margin: 30px 0;
    display: flex;
    justify-content: center;

    .nav_right {
      display: flex;
      justify-content: space-between;

      .count {
        margin-top: 10px;
        margin-right: 50px;
        font-size: 16px;
        font-weight: bold;

        span {
          color: #ff2a58;
        }
      }
    }
  }

  .nav_step {
    width: 50%;

    margin: 40px 0;
  }

  .nav_top {
    height: 40px;
    line-height: 40px;
    font-size: 20px;
    font-weight: bold;
  }

  .nav_content {
    display: flex;
    justify-content: space-between;

    p {
      font-size: 14px;
      height: 40px;
      line-height: 40px;
      font-weight: bold;
    }

    span {
      font-weight: normal;
      color: gray;
    }
  }
}

.nav_right {
  .startbtn {
    color: white;
    width: 100px;
    height: 40px;
    line-height: 20px;
    background-color: #c65442;
    padding: 10px;
  }

  .startbtn2 {
    width: 100px;
    height: 40px;
    background-color: rgb(255, 230, 230);
    border: 1px solid #c65442;
    color: #c65442;
  }
}

.main_top {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  margin-bottom: 40px;
  border-bottom: 2.5px dotted #e3e3e3;
}

.main_content {
  margin-top: 30px;
  padding-bottom: 50px;

  .pricebtn {
    border: 1px solid #c65442;
    color: #c65442;
  }
}

.main-flag {
  margin-bottom: 20px;

  // margin-left: 20px;
  b {
    display: inline-block;
    width: 3px;
    height: 18px;
    background: #c6523f;
    vertical-align: middle;
  }

  span {
    font-weight: bold;
    font-size: 18px;
    padding-left: 8px;
    vertical-align: middle;
  }
}

.flag_content {
  p {
    font-size: 14px;
    height: 30px;

    span {
      color: gray !important;
      font-size: 14px;
    }
  }
}

.exportBox {
  position: absolute;
  top: 50px;
  right: 100px;
  display: flex;
  align-items: center;
  width: 250px;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/views/procurementTenders/SupplierQuotation.vue